<template>
  <div class="e4s-flex-row e4s-gap--standard e4s-justify-flex-row-vert-center" @click="toggle">
    <span class="icon" v-if="showLeft">
      <ArrowDownSymbol :class="isOpen ? 'icon-open' : 'icon-closed'" />
    </span>
    <slot name="title-slot"><div v-text="title" class="e4s-subheader--300"></div></slot>
    <span class="icon" v-if="!showLeft">
      <ArrowDownSymbol :class="isOpen ? 'icon-open' : 'icon-closed'" />
    </span>
  </div>
</template>

<script setup lang="ts">
import ArrowDownSymbol from '@/common/ui/svg/ArrowDownSymbol.vue'
import { ref } from 'vue'

defineProps({
  title: {
    type: String,
    default: 'More Info...'
  },
  showLeft: {
    type: Boolean,
    default: true
  },
  closedCssClass: {
    type: String,
    default: 'icon-closed'
  },
  openCssClass: {
    type: String,
    default: 'icon-open'
  }
})

const emit = defineEmits<{
  (e: 'isOpen', value: boolean): void
}>()

const isOpen = ref(false)

function toggle() {
  isOpen.value = !isOpen.value
  emit('isOpen', isOpen.value)
}
</script>

<style scoped>
details {
  user-select: none;
}

.icon-closed {
  transform: rotate(0deg);
}

.icon-open {
  transform: rotate(180deg);
}
</style>
